module.exports = __webpack_public_path__ + "static/media/footer_logo_destinos.34c2c07c.png";